import { memo } from 'react'
import ReactMarkdown, { ReactMarkdownOptions } from 'react-markdown'
import { Components } from 'react-markdown/src/ast-to-react'
import {
  ListItem,
  Heading,
  Box,
  OrderedList,
  UnorderedList,
} from '@chakra-ui/react'

import DotDivider from 'atoms/DotDivider'
import { Body } from 'atoms/typography'
import theme from 'theme'
import { bodyLg } from 'theme/typography'

const components: Components = {
  ul: ({ children }) => (
    <UnorderedList my="6" spacing="6">
      {children}
    </UnorderedList>
  ),
  ol: ({ children }) => (
    <OrderedList my="6" spacing="6" fontSize={bodyLg.fontSize}>
      {children}
    </OrderedList>
  ),
  li: ({ children, ordered }) => (
    <ListItem
      _before={!ordered ? listItemSquare : undefined}
      listStyleType={!ordered ? 'none' : undefined}
      pl="4"
      position="relative"
    >
      <Body as="span">{children}</Body>
    </ListItem>
  ),
  p: ({ children }) => <Body>{children}</Body>,
  hr: () => (
    <Box my="6">
      <DotDivider />
    </Box>
  ),
  h2: ({ children }) => (
    <Heading size="md" my="3">
      {children}
    </Heading>
  ),
}

const listItemSquare = {
  position: 'absolute',
  display: 'inline-block',
  width: theme.sizes[2],
  height: theme.sizes[2],
  backgroundColor: theme.colors.grey,
  content: '""',
  top: '10px',
  left: `-${theme.sizes[4]}`,
}

export type MarkdownProps = ReactMarkdownOptions

const Markdown: React.FC<MarkdownProps> = ({ children, ...props }) => (
  <ReactMarkdown components={components} {...props}>
    {children}
  </ReactMarkdown>
)

const MarkdownMemoized = memo(Markdown)

export default MarkdownMemoized
